import { FormControl, Validators } from "@angular/forms";

export function requiredIfUsuario(predicate:any) {
  return ((control: FormControl) => {
    if (!control.parent) return null;
    if (predicate().value == 'Usuario') return Validators.required(control)
    return null;
  })
}

// export function requiredIfIntegracionA3(predicate:any) {
//   return ((control: FormControl) => {
//     if (!control.parent) return null;
//     if (predicate()) return Validators.required(control)
//     return null;
//   })
// }
